import { useState } from "react";

const Select = ({
    label,
    name,
    defaultValue,
    options = [],
    onChange = () => { }
}) => {
    const [state, setState] = useState(defaultValue);

    const handleChange = (event) => {
        const newState = event.target.value;

        setState(newState)
        onChange(name, newState)
    };

    return (
        <label className="block">
            <span className="text-gray-700">{label}</span>
            <select value={state} onChange={handleChange} name={name} className="block w-full mt-0 px-0.5 border-0 border-b-2 border-gray-200 focus:ring-0 focus:border-primary">
                {
                    options.map((option, index) => (
                        <option key={index} value={option}>{option}</option>
                    ))
                }
            </select>
        </label>
    );
}

export default Select;